const TellUs = __PATH_PREFIX__ + '/Landing/TellUsAboutYourCar.svg'
const WhatItsWorth = __PATH_PREFIX__ + '/Landing/SeeWhatItsWorth.svg'
const ChooseADealer = __PATH_PREFIX__ + '/Landing/ChooseAParticipatingDealer.svg'
const GetCash = __PATH_PREFIX__ + '/Landing/GetCashOrTradeInCredit.svg'

export default ({ dealerIsDirectToKBB = false, dealerIsDirectToKBBv2 = false, infoSteps = {} }) => {
  if (infoSteps.data && Array.isArray(infoSteps.data)) {
    const steps = infoSteps.data.map(step => ({
      ...step,
      image: addPathPrefixIfLocal(step.image)
    }))
    return steps
  }

  return dealerIsDirectToKBB || dealerIsDirectToKBBv2
    ? [
        { text: 'Tell Us About Your Car.', subText: "Tell us your car's specific features and condition.", image: TellUs, id: 'TellUs' },
        { text: 'Get the Instant Cash Offer.', subText: `Find out what you can get for your car today. Offers are good for 7 days.`, image: WhatItsWorth, id: 'GetOffer' },
        { text: 'Schedule Your Pick Up With Us.', subText: 'Your Kelley Blue Book Specialist will contact you to walk you through the process and help you schedule an at home pickup.', image: GetCash, id: 'GetCash' }
      ]
    : [
        { text: 'Tell Us About Your Car.', subText: "Tell us your car's specific features and condition.", image: TellUs, id: 'TellUs' },
        { text: 'Get the Instant Cash Offer.', subText: `Find out what you can get for your car today. Offers are good for 7 days.`, image: WhatItsWorth, id: 'GetOffer' },
        { text: 'Choose a Participating Dealer.', subText: "Bring in your car and offer. They'll verify the offer using the same questions you answered at home.", image: ChooseADealer, id: 'Dealer' },
        { text: 'Get Cash or Trade-In Credit.', subText: 'The offer is the same whether you sell or trade in.', image: GetCash, id: 'GetCash' }
      ]
}

const addPathPrefixIfLocal = imagePath => {
  const isLocal = imagePath.startsWith('/')
  return isLocal ? __PATH_PREFIX__ + imagePath : imagePath
}
